module.exports = __webpack_public_path__ + "static/media/boy-18.49968212.svg";